import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/icons/trade-network-currency.svg'
import _imports_1 from '../../../assets/icons/info-icon-transparent.svg'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "modal_form !tw-border-none tw-w-full" }
const _hoisted_4 = { class: "form_wrapper !tw-pb-4 !tw-flex !tw-flex-col !tw-items-start !tw-gap-1 tw-w-full" }
const _hoisted_5 = { class: "form_wrapper__title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "form_wrapper !tw-pb-4 !tw-flex !tw-flex-col !tw-items-start !tw-gap-1 tw-w-full" }
const _hoisted_8 = { class: "form_wrapper__title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_10 = { class: "form_wrapper !tw-pb-4 !tw-flex !tw-flex-col !tw-items-start !tw-gap-1 tw-w-full" }
const _hoisted_11 = { class: "form_wrapper__title" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "icon__wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "form_wrapper__tooltip_emergency" }, "Including the 1st Hour")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_14 = { class: "form_wrapper !tw-pb-4 !tw-flex !tw-flex-col !tw-items-start !tw-gap-1 tw-w-full" }
const _hoisted_15 = { class: "form_wrapper__title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_17 = { class: "form_wrapper !tw-pb-4 !tw-flex !tw-flex-col !tw-items-start !tw-gap-1 tw-w-full" }
const _hoisted_18 = { class: "form_wrapper__title" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "icon__wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "form_wrapper__tooltip" }, "Including the 1st Hour")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_21 = { class: "form_wrapper !tw-pb-4 !tw-flex !tw-flex-col !tw-items-start !tw-gap-1 tw-w-full" }
const _hoisted_22 = { class: "form_wrapper__title" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon__wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "form_wrapper__tooltip_inperson" }, "Including the 1st Hour")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_25 = { class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-justify-end tw-pt-4 tw-border-t-dashed-custom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    className: ['hourly_rate_modal'],
    width: "480px",
    height: "auto"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Text, {
            variant: "h6",
            textWeight: "400"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Edit Hourly & Day Rate")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            class: "tw-cursor-pointer",
            onClick: $setup.onClickCloseButton
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Hourly Rate")
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_text_field, {
              class: "input_field !tw-w-full",
              rules: $setup.validation.hourlyRate,
              modelValue: $setup.formattedHourlyRate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formattedHourlyRate) = $event)),
              onBlur: $setup.formatHourlyRate,
              variant: "outlined",
              placeholder: "0.00"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["rules", "modelValue", "onBlur"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Day Rate")
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_text_field, {
              class: "input_field !tw-w-full",
              rules: $setup.validation.dayRate,
              modelValue: $setup.formattedDayRate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formattedDayRate) = $event)),
              onBlur: $setup.formatDayRate,
              variant: "outlined",
              placeholder: "0.00"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["rules", "modelValue", "onBlur"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Emergency Call Out Fee")
                ]),
                _: 1
              }),
              _hoisted_12
            ]),
            _createVNode(_component_v_text_field, {
              class: "input_field !tw-w-full",
              rules: $setup.validation.emergencyCallOutFee,
              modelValue: $setup.formattedEmergencyCallOutFee,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formattedEmergencyCallOutFee) = $event)),
              onBlur: $setup.formatEmergencyCallOutFee,
              variant: "outlined",
              placeholder: "0.00"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["rules", "modelValue", "onBlur"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Emergency Call Out Rate (Per Hour)")
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_text_field, {
              class: "input_field !tw-w-full",
              rules: $setup.validation.emergencyCallOutRate,
              modelValue: $setup.formattedEmergencyCallOutRate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formattedEmergencyCallOutRate) = $event)),
              onBlur: $setup.formatEmergencyCallOutRate,
              variant: "outlined",
              placeholder: "0.00"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["rules", "modelValue", "onBlur"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Video Consultation Fee (Per Hour)")
                ]),
                _: 1
              }),
              _hoisted_19
            ]),
            _createVNode(_component_v_text_field, {
              class: "input_field !tw-w-full",
              rules: $setup.validation.VideoConsultationFee,
              modelValue: $setup.formattedVideoConsultationFee,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formattedVideoConsultationFee) = $event)),
              onBlur: $setup.formatVideoConsultationFee,
              variant: "outlined",
              placeholder: "0.00"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["rules", "modelValue", "onBlur"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("In person video rate")
                ]),
                _: 1
              }),
              _hoisted_23
            ]),
            _createVNode(_component_v_text_field, {
              class: "input_field !tw-w-full",
              rules: $setup.validation.inpersonVideoFees,
              modelValue: $setup.formattedinpersonVideoFees,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formattedinpersonVideoFees) = $event)),
              onBlur: $setup.formatinpersonVideoFees,
              variant: "outlined",
              placeholder: "0.00"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["rules", "modelValue", "onBlur"])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Button, {
            variant: "secondary",
            label: "Cancel",
            isCapitalize: true,
            onClick: $setup.onClickCloseButton,
            disabled: $setup.savingLoader,
            class: "!tw-w-auto"
          }, null, 8, ["onClick", "disabled"]),
          _createVNode(_component_Button, {
            variant: "accent",
            label: "Save",
            isCapitalize: true,
            isLoading: $setup.savingLoader,
            disabled: $setup.isSaveButtonDisable,
            onClick: $setup.onClickSaveButton,
            class: "!tw-w-auto"
          }, null, 8, ["isLoading", "disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}